/**
 * 請求先のCSV出力関連
 */　
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/settings/billing_addresses`

const setting_billing_address = {
  namespaced: true,
  actions: {
    /**
     * 売上品目単価CSV取得
     * @param commit
     * @param reference_date
     * @return {Promise<unknown>}
     */
    // index ({ commit }, { reference_date }) {
    //   let params = { reference_date: reference_date }
    //   return new Promise((resolve) => {
    //     Vue.$http.get(API_PATH, { params: params }).then(data => {
    //       resolve(data)
    //     })
    //   })
    // },
    /**
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, {headers: {'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default setting_billing_address
